import { PropsWithChildren, ReactNode } from 'react';

import {
  StyledBadgeCard,
  StyledIconWrapper,
  CardBadgeInvertedBorderRadius,
} from './styles';

export interface CardBadgeProps extends PropsWithChildren {
  startIcon?: ReactNode;
  endIcon?: ReactNode;
  disableInvertedBorderRadius?: boolean;
  hexColor?: string;
}

export default function CardBadge(props: CardBadgeProps) {
  const {
    startIcon,
    endIcon,
    children,
    disableInvertedBorderRadius,
    hexColor,
  } = props;

  return (
    <StyledBadgeCard hexColor={hexColor} className="informa-payment-card-badge">
      {startIcon && (
        <StyledIconWrapper className="informa-payment-card-badge__start-icon">
          {startIcon}
        </StyledIconWrapper>
      )}
      <div className="informa-payment-card-badge__content">{children}</div>
      {endIcon && (
        <StyledIconWrapper className="informa-payment-card-badge__end-icon">
          {endIcon}
        </StyledIconWrapper>
      )}
      {!disableInvertedBorderRadius && <CardBadgeInvertedBorderRadius />}
    </StyledBadgeCard>
  );
}
